import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { CompanySsoConfigurationService } from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '@wealthlane/api-services/wealthlane-award-service';

const usePostEnableDisableSso = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload?: { id: string; isEnabled?: boolean }) => {
      const response = await handleRequest(
        CompanySsoConfigurationService.postApiIdentityApiAppCompanySsoConfigurationEnableDisableSsoConfiguration(
          payload.id,
          payload.isEnabled
        )
      );
      return response;
    },
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries('getCompanySsoConfigList');
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostEnableDisableSso;
